import styles from '../Interview.module.scss'

type Props = {
  text: string
}

const SectionTitle: React.FC<Props> = ({ text }) => {
  return <h3 className={styles.title}>{text}</h3>
}
export default SectionTitle
